import { useDispatch } from "react-redux";
import {
  toggleHandStrength,
  toggleAutoTableSwitch,
  toggleAutoMuck,
  toggleAutoRebuy,
  toggleAutoBuyIn,
  toggleAutoTopup,
  handleAutoTopupFallsBelowSliderChange,
  handleAutoTopupSliderChange,
  handleShowEomjiToggle,
  handleShowThrowableToggle,
  updateCardSortingByRank,
} from "@/Poker/redux/slices/gameTableSlice";
import { setAutoBuyInPercentage } from "@/Poker/redux/slices/gameTableSlice";

export default function useApplyTableSettings() {
  const dispatch = useDispatch();

  const updateHandStrength = () => {
    try {
      console.log("Dispatching Action: toggleHandStrength");
      dispatch(toggleHandStrength());
    } catch (e) {
      console.error("Error updating hand strength:", e);
    }
  };

  const updateAutoTableSwitch = () => {
    try {
      console.log("Dispatching Action: toggleAutoTableSwitch");
      dispatch(toggleAutoTableSwitch());
    } catch (e) {
      console.error("Error updating auto table switch:", e);
    }
  };

  const updateAutoMuck = () => {
    try {
      console.log("Dispatching Action: toggleAutoMuck");
      dispatch(toggleAutoMuck());
    } catch (e) {
      console.error("Error updating auto muck:", e);
    }
  };

  const updateAutoRebuy = () => {
    try {
      console.log("Dispatching Action: toggleAutoRebuy");
      dispatch(toggleAutoRebuy());
    } catch (e) {
      console.error("Error updating auto rebuy:", e);
    }
  };

  const updateAutoBuyIn = () => {
    try {
      console.log("Dispatching Action: toggleAutoBuyIn");
      dispatch(toggleAutoBuyIn());
    } catch (e) {
      console.error("Error updating auto buy-in:", e);
    }
  };

  const updateAutoBuyInPercentage = (percentage) => {
    try {
      console.log("Dispatching Action: toggleAutoBuyIn");
      dispatch(setAutoBuyInPercentage({ percentage: percentage }));
    } catch (e) {
      console.error("Error updating auto buy-in:", e);
    }
  };

  const updateAutoTopup = () => {
    try {
      console.log("Dispatching Action: toggleAutoTopup");
      dispatch(toggleAutoTopup());
    } catch (e) {
      console.error("Error updating auto topup:", e);
    }
  };

  const updateAutoTopupFallsBelow = (value) => {
    try {
      console.log(
        "Dispatching Action: handleAutoTopupFallsBelowSliderChange",
        value
      );
      dispatch(handleAutoTopupFallsBelowSliderChange({ value }));
    } catch (e) {
      console.error("Error updating auto topup falls below:", e);
    }
  };

  const updateAutoTopupAmount = (value) => {
    try {
      console.log("Dispatching Action: handleAutoTopupSliderChange", value);
      dispatch(handleAutoTopupSliderChange({ value }));
    } catch (e) {
      console.error("Error updating auto topup amount:", e);
    }
  };
  const updateEmojiToggle = (value) => {
    try {
      dispatch(handleShowEomjiToggle({ value }));
    } catch (e) {
      console.error("Error updating emoji toggle:", e);
    }
  };
  const updateThrowableToggle = (value) => {
    try {
      console.log("Dispatching Action: handleAutoTopupSliderChange", value);
      dispatch(handleShowThrowableToggle({ value }));
    } catch (e) {
      console.error("Error updating throwable toggle:", e);
    }
  };

  const updateCardSortingSetting = () => {
    try {
      console.log("Dispatching Action: updateCardSortingByRank");
      dispatch(updateCardSortingByRank());
    } catch (e) {
      console.error("Error updating card sorting by rank:", e);
    }
  };

  // Add more update functions as needed

  return {
    updateHandStrength,
    updateAutoTableSwitch,
    updateAutoMuck,
    updateAutoRebuy,
    updateAutoBuyIn,
    updateAutoBuyInPercentage,
    updateAutoTopup,
    updateAutoTopupFallsBelow,
    updateAutoTopupAmount,
    updateEmojiToggle,
    updateThrowableToggle,
    updateCardSortingSetting,
    // Add more update functions as needed
  };
}
